import { Database } from "firebase-firestore-lite"

// All you need is the projectId. It can be found on the firebase console and in the firebase config.
const db = new Database({ projectId: "beyondcompany" })

const mail = db.ref("mail")

export { mail }
